// src/app/modules/demandes/DemandeFormModal.jsx
import React, { useEffect, useState } from "react";
import "../../RessourcesStyles/DemandeFormModal.css";

const defaultForm = {
    mode: "",
    period: "",
    niveau: "",
    certifiante: false,
    priorite: 2,
    objectifs: "",
    objectifs2: "",
    objectifs3: "",
    action: "",
    description: "",
    domaineId: "",
    themeId: "",
};

const PERIOD_OPTIONS = ["Q1", "Q2", "Q3", "Q4"];
const NIVEAU_OPTIONS = ["Débutant", "Intermédiaire", "Avancé"];
const MODE_OPTIONS = ["Distanciel", "Présentiel", "Hybride"];

export default function DemandeFormModal({
    open,
    onClose,
    onSubmit,
    formation,
    campagneId,
    type = "FORMATION",
    domaines = [],
    themes = [],
    loading = false,
    requireCampagneSelection = true,
}) {
    const [form, setForm] = useState(defaultForm);

    useEffect(() => {
        if (!open) return;
        setForm({
            ...defaultForm,
            priorite: 2,
        });
    }, [open]);

    if (!open) return null;

    const update = (key, value) => setForm((current) => ({ ...current, [key]: value }));
    const isSubmitDisabled = loading || (requireCampagneSelection && !campagneId);

    const handleSubmit = (event) => {
        event.preventDefault();

        onSubmit?.({
            campagneId,
            type,
            formationId: type === "FORMATION" ? formation?.id : null,
            mode: form.mode || null,
            period: form.period || null,
            niveau: form.niveau || null,
            certifiante: !!form.certifiante,
            priorite: form.priorite === "" ? null : Number(form.priorite),
            objectifs: form.objectifs || null,
            objectifs2: form.objectifs2 || null,
            objectifs3: form.objectifs3 || null,
            action: form.action || null,
            description: form.description || null,
            domaineId: form.domaineId ? Number(form.domaineId) : null,
            themeId: form.themeId ? Number(form.themeId) : null,
        });
    };

    return (
        <div className="demande-modal-overlay" onMouseDown={onClose}>
            <div
                className="demande-modal"
                onMouseDown={(event) => event.stopPropagation()}
                role="dialog"
                aria-modal="true"
            >
                <div className="demande-modal-header">
                    <div className="demande-modal-title">
                        {type === "FORMATION" ? "Demander une formation" : "Demande hors catalogue"}
                    </div>
                    <button className="demande-modal-close" onClick={onClose} type="button" aria-label="Fermer">
                        ×
                    </button>
                </div>

                <div className="demande-modal-subtitle">
                    {type === "FORMATION" ? (
                        <span>
                            Formation : <b>{formation?.nom || formation?.name || "Sélectionner..."}</b>
                        </span>
                    ) : (
                        <span>Merci de renseigner les informations</span>
                    )}
                </div>

                <form className="demande-form" onSubmit={handleSubmit}>
                    <div className="demande-grid-2">
                        <div className="field">
                            <label>Mode</label>
                            <select value={form.mode || ""} onChange={(event) => update("mode", event.target.value)}>
                                <option value="">Sélectionner...</option>
                                {MODE_OPTIONS.map((mode) => (
                                    <option key={mode} value={mode}>
                                        {mode}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="field">
                            <label>Période</label>
                            <select value={form.period || ""} onChange={(event) => update("period", event.target.value)}>
                                <option value="">Sélectionner...</option>
                                {PERIOD_OPTIONS.map((period) => (
                                    <option key={period} value={period}>
                                        {period}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="field">
                            <label>Niveau</label>
                            <select value={form.niveau || ""} onChange={(event) => update("niveau", event.target.value)}>
                                <option value="">Sélectionner...</option>
                                {NIVEAU_OPTIONS.map((niveau) => (
                                    <option key={niveau} value={niveau}>
                                        {niveau}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="field">
                            <label>Priorité</label>
                            <select value={form.priorite} onChange={(event) => update("priorite", event.target.value)}>
                                <option value={1}>1 - Haute</option>
                                <option value={2}>2 - Moyenne</option>
                                <option value={3}>3 - Basse</option>
                            </select>
                        </div>

                        <div className="field field-inline">
                            <label>Certifiante</label>
                            <input
                                type="checkbox"
                                checked={!!form.certifiante}
                                onChange={(event) => update("certifiante", event.target.checked)}
                            />
                        </div>
                    </div>

                    <div className="field">
                        <label>Objectifs (1)</label>
                        <textarea value={form.objectifs} onChange={(event) => update("objectifs", event.target.value)} />
                    </div>
                    <div className="field">
                        <label>Objectifs (2)</label>
                        <textarea value={form.objectifs2} onChange={(event) => update("objectifs2", event.target.value)} />
                    </div>
                    <div className="field">
                        <label>Objectifs (3)</label>
                        <textarea value={form.objectifs3} onChange={(event) => update("objectifs3", event.target.value)} />
                    </div>

                    {type === "HORS_CATALOGUE" && (
                        <>
                            <div className="demande-grid-2">
                                <div className="field">
                                    <label>Domaine</label>
                                    <select value={form.domaineId} onChange={(event) => update("domaineId", event.target.value)}>
                                        <option value="">Sélectionner...</option>
                                        {domaines.map((domaine) => (
                                            <option key={domaine.id} value={domaine.id}>
                                                {domaine.nom || domaine.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="field">
                                    <label>Thème</label>
                                    <select value={form.themeId} onChange={(event) => update("themeId", event.target.value)}>
                                        <option value="">Sélectionner...</option>
                                        {themes.map((theme) => (
                                            <option key={theme.id} value={theme.id}>
                                                {theme.nom || theme.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            <div className="field">
                                <label>Action / Intitulé</label>
                                <input value={form.action} onChange={(event) => update("action", event.target.value)} />
                            </div>

                            <div className="field">
                                <label>Description</label>
                                <textarea
                                    value={form.description}
                                    onChange={(event) => update("description", event.target.value)}
                                    rows={4}
                                />
                            </div>
                        </>
                    )}

                    <div className="demande-actions">
                        <button type="button" className="btn btn-light" onClick={onClose}>
                            Annuler
                        </button>
                        <button type="submit" className="btn btn-primary" disabled={isSubmitDisabled}>
                            {loading ? "Envoi..." : "Envoyer la demande"}
                        </button>
                    </div>

                    {requireCampagneSelection && !campagneId && (
                        <div className="demande-hint">Sélectionne d'abord une campagne.</div>
                    )}
                </form>
            </div>
        </div>
    );
}
